export default __webpack_public_path__ + "static/media/haitek.7b39ae1b.jpg";